import { GET_TEAMS, GET_TEAM, TEAM_LOADING } from "../actions/types";

const initialState = {
  teams: null,
  team: null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TEAM_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_TEAMS:
      return {
        ...state,
        teams: action.payload,
        loading: false,
      };
    case GET_TEAM:
      return {
        ...state,
        team: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
